import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  timelineSectionsHeader: {
    margin: '0',
    fontSize: '16px',
    fontWeight: 500,
    color: 'var(--text-primary)',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 0 6px 0',
    gap: '8px',

    '& .searchInputWrapper': {
      width: '100%',
    },

    '@media screen and (min-width: 1441px)': {
      padding: '0 0 14px 0',
    },
  },

  buttons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',

    '& .viboButton': {
      whiteSpace: 'nowrap',
    },
  },

  noButtons: {
    display: 'none',
  },
}));

export default useStyles;
